import styled from 'styled-components'
import { Box, Flex, SelectDropdown } from '@sketch/components'
import { breakpoint } from '@sketch/global-styles'
import { DatePicker as SharedDatePicker } from '../../../activity/components/Notifications/NotificationSearch/NotificationSearch.styles'

const ACTION_FILTER_WIDTH = 200

export const ActionFilterWrapper = styled(Box)`
  flex: 0 1 ${ACTION_FILTER_WIDTH}px;
  min-width: 0;
`

export const ActionSelectDropdown = styled(SelectDropdown)`
  box-sizing: border-box;
  max-width: 100%;
  min-width: 0;
  min-height: 32px;
  height: 32px;
  padding-top: 0;
  padding-bottom: 0;
  line-height: 32px;
` as typeof SelectDropdown

export const FilterBar = styled(Flex)`
  width: 100%;
  min-width: 0;
  flex-wrap: nowrap;
  gap: 8px;

  > :first-child {
    margin-left: auto;
  }

  > :not(:first-child) {
    flex-shrink: 0;
  }

  ${breakpoint('base', 'md')`
    flex-wrap: wrap;

    > :first-child {
      flex: 0 0 100%;
      margin-left: 0;
    }

    > :not(:first-child) {
      flex-shrink: 1;
    }

    > :last-child {
      flex-shrink: 0;
      align-self: flex-end;
    }
  `}
`

export const DateFilterLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  font-size: ${({ theme }) => theme.fontSizes.D};
  white-space: nowrap;

  ${breakpoint('base', 'md')`
    flex: 1 1 0;
    min-width: 0;
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
  `}
`

export const DatePicker = styled(SharedDatePicker)`
  box-sizing: border-box;
  width: 125px;
  height: 32px;
  padding: 4px 8px;
  color: ${({ theme }) => theme.colors.foreground.secondary.A};

  ${breakpoint('base', 'md')`
    width: 100%;
    min-width: 0;
  `}
`
